import {InputImageType} from './images-type';

export const DEFAULT_INPUT_IMAGE: InputImageType = {
    id: null,
    file: null,
    httpUrl: '',
    objectUrl: '',
};
